import PropTypes from "prop-types";
import React from "react";

const hero = ({ background, children, large, isAnemia, isAnemia2 }) => (
	<div
		className={`hero ${large ? "hero-large" : ""} ${isAnemia ? "hero-anemia" : ""} ${isAnemia2 ? "hero-anemia2" : ""}`}
		style={{
			backgroundImage: `url(${background})`,
		}}
	>
		<div className="container">
			<div className="row">{children}</div>
		</div>
	</div>
);

hero.propTypes = {
	background: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	large: PropTypes.bool,
	isAnemia: PropTypes.bool,
	isAnemia2: PropTypes.bool
};

export default hero;
